import { useEffect, useState } from "react";

/**
 * Leaves the app for `url` and reports that the redirect is under way. Back restores the page from the
 * browser's cache with that state, so it resets when the page shows again.
 */
export function useFullPageRedirect() {
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const reset = () => setIsRedirecting(false);
    window.addEventListener("pageshow", reset);
    return () => window.removeEventListener("pageshow", reset);
  }, []);

  const redirect = (url: string) => {
    setIsRedirecting(true);
    window.location.assign(url);
  };

  return { isRedirecting, redirect };
}
